module.exports = "<!--<div class=\"container-fluid padding-t-b-20\">\n    <span class=\"float-left\">\n        <span>Copyright © <a class=\"brand\" target=\"_blank\" [href]=\"AppConfig.productLink\">{{AppConfig.brand}}</a> {{AppConfig.year}}</span>\n    </span>\n    <span class=\"float-right\">\n        <span>Built with Love <i class=\"material-icons\">favorite_border</i></span>\n    </span>\n</div>-->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/footer/footer.component.html
// module id = 1265
// module chunks = 10